import React, { useEffect } from 'react'
import { Button } from '../../../components/button'
import AccountForm from '../../../components/forms/account-form'
import { useDispatch, useSelector } from 'react-redux'
import { getCurrentAccount } from '../../../slices/accounts'


const Account = () => {

    const dispatch = useDispatch()
    const currentAccount = useSelector((state) => state.accounts.currentAccount)
    const loadingUpdate = useSelector((state) => state.accounts.loadingUpdate)

    useEffect(() => {
        dispatch(getCurrentAccount())
    }, [])

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col px-0">
                        <h1 className="title">{gettext('Account details')} { loadingUpdate && <>{gettext("Saving")}</>}</h1>
                    </div>
                </div>
            </div>
            {currentAccount &&
                <AccountForm account={currentAccount} />
            }
        </>
    )
}

export default Account